<template>
    <div class="team-rank">
		<div class="header">
			<BackTitle title="战队信息" />
			<div class="header-right">
				<div class="team-name">
                    <img src="../images/icon-team.png" class="team-icon" alt="">
                    {{ classInfo.name }}
                </div>
                <WeekSelect :options="weekList" v-model="selectedWeek" @change="getRankList">
                    <template v-slot:prefix>
                        <img src="../images/icon-calendar.png" class="week-icon" alt="">
                    </template>
                </WeekSelect>
			</div>
		</div>

        <div class="main">
            <div class="content">
                <div class="content-header">
                    <div class="header-tabs">
                        <span
                            class="header-tab"
                            :class="{ 'header-tab-active': activeTab === CourseType.WU }"
                            @click="toggleTab(CourseType.WU)">
                            <img v-if="activeTab === CourseType.WU" src="../images/wu-active.png" alt="" class="tab-icon">
                            <img v-else src="../images/wu.png" alt="" class="tab-icon">
                            武功
                        </span>
                        <span
                            class="header-tab"
                            :class="{ 'header-tab-active': activeTab === CourseType.WEN }"
                            @click="toggleTab(CourseType.WEN)">
                            <img v-if="activeTab === CourseType.WEN" src="../images/wen-active.png" alt="" class="tab-icon">
                            <img v-else src="../images/wen.png" alt="" class="tab-icon">
                            文功
                        </span>
                    </div>
                </div>
                <div class="content-body">
                    <div class="rank-table">
                        <div class="item-wrapper">
                            <div class="table-header">
                                <div class="header-cell rank-cell">排名</div>
                                <div class="header-cell user-cell">用户</div>
                                <div v-for="item in otherHeaders" :key="item" class="header-cell level-cell">{{item}}</div>
                            </div>
                        </div>
                        <div class="rank-list">
                            <div v-if="!rankList.length" class="empty-tip">
                                暂无数据！
                            </div>
                            <template v-else>
                                <div v-for="(item, index) in rankList" :key="index" class="item-wrapper">
                                    <div class="rank-item">
                                        <div class="rank-number rank-cell">
                                            <img v-if="item.ranking < 3" :src="getRankIcon(item.ranking)" class="rank-medal" />
                                            <span v-else class="rank-text">{{ item.ranking }}</span>
                                        </div>
                                        <div class="user-info user-cell" @click="onToUserDetail(item)">
                                            <img :src="item.avatar" class="user-avatar" />
                                            <span class="user-name">{{ item.name }}</span>
                                        </div>
                                        <div v-for="(level, levelIndex) in item.levels" :key="levelIndex" class="level-stars level-cell">
                                            <div v-if="level === '未通关'" class="level-incomplete level-cell">
                                                未通关
                                            </div>
                                            <template v-else>
                                                <span v-for="star in 5" :key="star" class="icon-star" :class="{ 'star-filled': star <= level }"></span>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import BackTitle from "@/components/back-title/BackTitle.vue"
import { CourseType } from '@/constants/enum'
import { apiQueryDataPage } from "@/models/datacenter"
import { apiGetMallUserInfo } from "@/models/mall"
import WeekSelect from "./components/WeekSelect.vue";
import IconNum1 from "../images/icon-num1.png";
import IconNum2 from "../images/icon-num2.png";
import IconNum3 from "../images/icon-num3.png";

export default {
    name: 'team-rank',
    components: {
        BackTitle,
        WeekSelect,
    },
    data() {
        return {
            CourseType,
            activeTab: CourseType.WU,
            classInfo: {},
            otherHeaders: [],
            rankList: [],
            weekList: [],
            selectedWeek: '',
        }
    },
    computed: {
        ...mapState({
            userInfo: state => state.user.user,
        })
    },
    methods: {
        getRankIcon(rank) {
            if (rank === 1) {
                return IconNum1
            } else if (rank === 2) {
                return IconNum2
            } else if (rank === 3) {
                return IconNum3
            }
        },
        async getUserInfo() {
            const {data} = await apiGetMallUserInfo()
            this.classInfo = data.classInfo || {}
        },
        toggleTab(type) {
            if (this.activeTab === type) {
                return
            }
            this.activeTab = type
            this.getRankList()
        },
        async getRankList() {
            const result = await apiQueryDataPage({
                "name": "mall_class_lesson_complete_info_AT",
                "page":false,
                "params": {
                    "classId": this.classInfo.id,
                    "pushTime": this.selectedWeek,
                    "type": this.activeTab,
                }
            })
            const studyData = JSON.parse(result.data.items[0]?.[3] || "[]")
            this.otherHeaders = studyData?.map(item => `${item.dan_name}${item.cus_name}`) || []
            this.rankList = result.data.items.map(item => ({
                ranking: item[0],
                name: item[1],
                avatar: item[2],
                levels: JSON.parse(item[3])?.map(level => level.star) || [],
                userId: item[4],
                userCode: item[5],
            }))
        },
        // 获取推课周
        async getPushWeek() {
            const result = await apiQueryDataPage({
                "name": "class_schedule_list_AT",
                "page":false,
                "params": {
                    "classId": this.classInfo.id,
                }
            })
            this.weekList = result.data.items.map(item => ({
                startTime: item[0],
                endTime: item[1],
                weekId: item[3],
            })).reverse().splice(0, 30)
            this.selectedWeek = this.weekList?.[0]?.startTime
        },

        onToUserDetail(item) {
            this.$router.push({
                name: 'team-user-detail',
                query: {
                    userId: item.userId,
                    userCode: item.userCode,
                }
            })
        },
    },
    async created() {
        await this.getUserInfo()
        await this.getPushWeek()
        this.getRankList()
    }
}
</script>

<style scoped>
.team-rank {
	box-sizing: border-box;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
	padding-top: 24px;
	background: url("../images/flower-bg.png") center/cover no-repeat;
    overflow: hidden;
}

.header {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.header-right {
	display: flex;
	align-items: center;
	padding-right: 28px;
}
.team-name {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 24px;
    background: #fff3d3;
    box-shadow: 0px 1px 3px 0px rgba(153,37,6,0.41), 0px -2px 4px 0px #ecc596 inset; 
    border-radius: 30px;
    font-size: 24px;
    font-weight: bold;
    color: #706D69;
}
.team-icon {
    width: 26px;
    height: 30px;
}
.week-icon {
    width: 32px;
    height: 32px;
}

.main {
    flex: 1;
    padding: 36px;
    overflow: hidden;
}
.content {
    display: flex;
    flex-direction: column;
    height: 100%;
    background: #f9e1a3;
    border-radius: 50px;
    box-shadow: 0px 1px 3px 0px rgba(103,27,6,0.23), 0px -1px 1px 0px rgba(217,138,67,0.80) inset;
}

.content-header {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 68px;
    background: #facf5d;
    border-radius: 50px 50px 0px 0px;
    box-shadow: 0px 1px 3px 0px rgba(103,27,6,0.23), 0px -1px 1px 0px rgba(217,138,67,0.80) inset; 
}
.header-tabs {
    display: flex;
    align-items: center;
    padding: 4px;
    background: #e9af43;
    border-radius: 28px;
    box-shadow: 0px 1px 0px 0px rgba(255,239,175,0.43), 0px 0px 3.48px 0.52px rgba(205,87,51,0.39) inset; 
}
.header-tab {
    display: flex;
    align-items: center;
    padding: 10px 48px;
    font-size: 24px;
    line-height: 1;
    font-weight: bold;
    color: #fff;
    cursor: pointer;
}
.header-tab-active {
    background: #ffe952;
    border-radius: 28px;
    box-shadow: 0px 1px 3px 0px rgba(153,37,6,0.41), 0px -3px 4px 0px #ffbe31 inset; 
    color: #DD7146;
}
.tab-icon {
    width: 32px;
    height: 32px;
    margin-right: 16px;
}
.content-body {
    flex: 1;
    padding: 20px;
    overflow: hidden;
}

.rank-table {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow: auto;
}
.rank-table::-webkit-scrollbar {
    display: none;
}

.table-header {
    display: flex;
    align-items: center;
    padding: 12px 24px;
    background: #fff3d3;
    box-shadow: 0px 1px 3px 0px rgba(153,37,6,0.41), 0px -2px 4px 0px #ecc596 inset; 
    border-radius: 16px;
    margin-bottom: 12px;
    font-size: 22px;
    font-weight: bold;
    color: #A49A7E;
}

.header-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.rank-cell {
    width: 80px;
    margin-right: 20px;
}

.user-cell {
    width: 200px;
}

.level-cell {
    flex-shrink: 0;
    width: 180px;
    padding: 0 20px;
}

.rank-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.empty-tip {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 100px 0;
    font-size: 32px;
    color: #e16a09;
    font-weight: bold;
}
.rank-item {
    display: flex;
    align-items: center;
    padding: 0 24px;
    background: rgba(255, 255, 255, 0.6);
    border-radius: 16px;
}

.rank-number {
    display: flex;
    align-items: center;
    justify-content: center;
}

.rank-medal {
    width: 62px;
    height: 74px;
}

.rank-text {
    font-size: 30px;
    font-weight: bold;
    color: #4F4C48;
}

.user-info {
    display: flex;
    align-items: center;
    gap: 12px;
}

.user-avatar {
    width: 48px;
    height: 48px;
    border-radius: 50%;
}

.user-name {
    font-size: 16px;
    color: #333;
}

.item-wrapper {
    display: flex;
}

.level-stars {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
}

.icon-star {
    width: 32px;
    height: 32px;
    background: url('../images/star.png') center/100% no-repeat;
}

.icon-star.star-filled {
    background: url('../images/star-active.png') center/100% no-repeat;
}

.level-incomplete {
    min-width: 120px;
    color: #827D77;
    font-size: 23px;
    font-weight: bold;
    text-align: center;
}
</style>